import { useState } from 'react';

interface iUseModal {
	open: boolean;
	close: boolean;
	openModal: () => void;
	closeModal: () => void;
}

/**
 * Manages open/close state for a modal dialog.
 *
 * @returns An object with:
 * - `open` — `true` while the modal is open.
 * - `close` — `true` after `closeModal` has been called at least once.
 * - `openModal` — sets `open` to `true`.
 * - `closeModal` — sets `open` to `false` and marks `close` as `true`.
 *
 * @example
 * const { open, openModal, closeModal } = useModal();
 * // <Button onClick={openModal}>Open</Button>
 * // <Dialog open={open} onClose={closeModal} />
 */
const useModal = (): iUseModal => {
	const [open, onOpenModal] = useState(false);
	const [close, onCloseModal] = useState(false);

	const openModal = () => {
		onOpenModal(true);
	};

	const closeModal = () => {
		onCloseModal(true);
		onOpenModal(false);
	};

	return { open, close, openModal, closeModal };
};

export default useModal;
